<app-main-wrapper title="Opportunities">
  <div class="wrapper">
    @if (isLoading) {
      <div class="state-container">
        <div class="spinner"></div>
        <p>Loading your opportunities...</p>
      </div>
    } @else if (sortedOpportunities.length === 0) {
      <div class="state-container">
        <div class="empty-state-icon">
          <i class="fa-regular fa-calendar-xmark"></i>
        </div>
        <h3>No opportunities found</h3>
        <p>Schedule a meeting in your Google Calendar and it will automatically appear here.</p>
      </div>
    } @else {
      <!-- Mobile-only sort controls: the table header (and its sort affordance)
           is hidden once rows collapse into cards at phone widths. -->
      <div class="opp-sort-bar">
        <span class="opp-sort-bar__label">Sort by</span>
        <button
          type="button"
          class="opp-sort-chip"
          [class.active]="sortField === 'opportunity_name'"
          (click)="sortBy('opportunity_name')"
        >
          Name
          <i
            *ngIf="sortField === 'opportunity_name'"
            class="fa-solid"
            [ngClass]="sortDirection === 'asc' ? 'fa-arrow-up' : 'fa-arrow-down'"
          ></i>
        </button>
        <button
          type="button"
          class="opp-sort-chip"
          [class.active]="sortField === 'updated_at'"
          (click)="sortBy('updated_at')"
        >
          Updated
          <i
            *ngIf="sortField === 'updated_at'"
            class="fa-solid"
            [ngClass]="sortDirection === 'asc' ? 'fa-arrow-up' : 'fa-arrow-down'"
          ></i>
        </button>
      </div>

      <table class="opp-table">
        <thead>
          <tr>
            <th
              class="col-name sortable"
              [class.active]="sortField === 'opportunity_name'"
              (click)="sortBy('opportunity_name')"
            >
              Name
              <i
                *ngIf="sortField === 'opportunity_name'"
                class="fa-solid sort-icon"
                [ngClass]="
                  sortDirection === 'asc' ? 'fa-arrow-up' : 'fa-arrow-down'
                "
              ></i>
            </th>
            <th *ngIf="shouldShowCrmColumn" class="col-crm">CRM</th>
            <th
              class="col-date sortable"
              [class.active]="sortField === 'updated_at'"
              (click)="sortBy('updated_at')"
            >
              Updated
              <i
                *ngIf="sortField === 'updated_at'"
                class="fa-solid sort-icon"
                [ngClass]="
                  sortDirection === 'asc' ? 'fa-arrow-up' : 'fa-arrow-down'
                "
              ></i>
            </th>
            <th class="col-action"></th>
          </tr>
        </thead>
        <tbody>
          @for (
            oppportunityDetail of sortedOpportunities;
            track oppportunityDetail.id;
            let i = $index
          ) {
            <tr
              class="opp-row"
              [style.--row-index]="i"
              [class.opp-row--disabled]="!hasPastMeetings(oppportunityDetail)"
              (click)="
                hasPastMeetings(oppportunityDetail) &&
                  openDeatilPage(oppportunityDetail)
              "
            >
              <td class="opp-name">{{ oppportunityDetail.opportunity_name }}</td>
              <td *ngIf="shouldShowCrmColumn" class="opp-crm">
                @if (isOpportunityMapped(oppportunityDetail)) {
                  <span
                    class="crm-mapped-badge"
                    [attr.aria-label]="connectedCrmProvider + ' mapped'"
                  >
                    <span
                      class="crm-provider-logo"
                      [ngClass]="'crm-provider-logo--' + connectedCrmProvider"
                      aria-hidden="true"
                    >
                      @if (connectedCrmProvider === "salesforce") {
                        <i class="fa-brands fa-salesforce"></i>
                      } @else if (connectedCrmProvider === "hubspot") {
                        <i class="fa-brands fa-hubspot"></i>
                      } @else {
                        <img
                          src="https://www.zoho.com/favicon.ico"
                          alt="Zoho"
                          class="crm-provider-favicon"
                          loading="lazy"
                        />
                      }
                    </span>
                    <i
                      class="fa-solid fa-circle-check crm-mapped-check"
                      aria-hidden="true"
                    ></i>
                  </span>
                } @else {
                  <span class="crm-unmapped-badge" aria-label="Not mapped">
                    <i
                      class="fa-solid fa-circle-xmark crm-unmapped-cross"
                      aria-hidden="true"
                    ></i>
                  </span>
                }
              </td>
              <td class="opp-date">
                @if (hasPastMeetings(oppportunityDetail)) {
                  {{ getUpdatedAtValue(oppportunityDetail) | date: "d MMM, y" }}
                } @else {
                  <span class="opp-date--empty">No past meetings</span>
                }
              </td>
              <td class="opp-action-cell">
                @if (hasPastMeetings(oppportunityDetail)) {
                  <span class="opp-action">
                    <span class="opp-action__label">View</span>
                    <i class="fa-solid fa-chevron-right opp-action__icon"></i>
                  </span>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    }
  </div>
</app-main-wrapper>

<!-- Companion prompt (shown once after activating the Free plan) -->
@if (showCompanionPrompt) {
  <div class="companion-modal-overlay" (click)="dismissCompanionPrompt()">
    <div class="companion-modal" (click)="$event.stopPropagation()">
      <button
        type="button"
        class="companion-modal__close"
        aria-label="Close"
        (click)="dismissCompanionPrompt()"
      >
        <i class="fa-solid fa-xmark"></i>
      </button>

      <div class="companion-modal__icon">
        <i class="fa-solid fa-users"></i>
      </div>

      <h2 class="companion-modal__title">You're all set!</h2>
      <p class="companion-modal__text">
        Head over to the companion app to start taking meetings and get live,
        in-call assistance from convverse.
      </p>

      <div class="companion-modal__actions">
        <button type="button" class="companion-modal__btn-primary" (click)="openCompanion()">
          Open companion
        </button>
        <button type="button" class="companion-modal__btn-secondary" (click)="dismissCompanionPrompt()">
          Maybe later
        </button>
      </div>
    </div>
  </div>
}
